import { render, staticRenderFns } from "./SupplierCategories.vue?vue&type=template&id=d3faa934&scoped=true&"
import script from "./SupplierCategories.vue?vue&type=script&lang=js&"
export * from "./SupplierCategories.vue?vue&type=script&lang=js&"
import style0 from "./SupplierCategories.vue?vue&type=style&index=0&id=d3faa934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3faa934",
  null
  
)

export default component.exports